import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon, BorderSelect } from 'Permafrost/index';
import { StyledSectionTable } from './SectionTable.styles';
const createTitle = (item) => {
    return typeof item === 'string' || typeof item === 'number' ? item : null;
};
export const SectionTable = (props) => {
    const [openRowOptions, changeOpenRowOptions] = useState([]);
    const handleRowClick = (link) => {
        if (!link) {
            return null;
        }
        return (e) => {
            e.stopPropagation();
            props.history.push(link);
        };
    };
    const handleRowOptionToggleClick = (id) => {
        if (openRowOptions.indexOf(id) === -1) {
            changeOpenRowOptions([].concat(openRowOptions, id));
        }
        else {
            changeOpenRowOptions(openRowOptions.filter((option) => option !== id));
        }
        if (props.openRowOptionHandler) {
            props.openRowOptionHandler(id);
        }
    };
    const headers = Object.keys(props.tableObjects[0].content);
    return (React.createElement(StyledSectionTable, { className: classNames('SectionTable', props.className, { loading: props.loading }), "data-cy": props['data-cy'], id: props.id },
        props.sortColumnHandler && props.sortedColumn && (React.createElement("div", { className: "mobile-sort" },
            React.createElement(BorderSelect, { onChange: (e) => props.sortColumnHandler(e.target.value), value: props.sortedColumn, options: [].concat({ name: 'Choose Sorting Option', value: '' }, headers.map((item) => {
                    return { name: item, value: item };
                })) }))),
        React.createElement("table", Object.assign({}, props.tableProps),
            React.createElement("thead", null,
                React.createElement("tr", null,
                    props.tableObjects[0].rowAccordionContent ? React.createElement("th", { className: "action-column" }) : null,
                    headers.map((header, i) => {
                        return (React.createElement("th", { className: classNames({
                                'not-sortable': props.sortableHeaders && props.sortableHeaders.indexOf(header) === -1,
                            }), onClick: () => {
                                if (props.sortColumnHandler) {
                                    if (props.sortableHeaders) {
                                        if (props.sortableHeaders.indexOf(header) !== -1) {
                                            props.sortColumnHandler(header);
                                        }
                                    }
                                    else {
                                        props.sortColumnHandler(header);
                                    }
                                }
                            }, key: i },
                            props.headersContent ? props.headersContent[header] : header,
                            ' ',
                            props.sortedColumn === header && (React.createElement(Icon, { name: `fa-caret-${props.sortDirection}` }))));
                    }))),
            React.createElement("tbody", { className: classNames({ 'SectionTable--tbody-loading': props.loading }) }, props.loading
                ? Array.from({ length: 5 }, (x, i) => (React.createElement("tr", { key: i }, props.tableObjects[0].rowAccordionContent ? (React.createElement("td", { colSpan: headers.length + 1 })) : (React.createElement("td", { colSpan: headers.length })))))
                : props.tableObjects.map((obj, i) => {
                    let rowStyle = obj.rowStyleCondition;
                    if (rowStyle) {
                        rowStyle = { [rowStyle.className]: rowStyle.condition };
                    }
                    if (obj.rowAccordionContent) {
                        return (React.createElement("tr", Object.assign({ key: i, className: classNames(rowStyle) }, props.rowProps),
                            React.createElement("td", { colSpan: headers.length + 1, style: { padding: '0' }, className: "outer-hover" },
                                React.createElement("table", null,
                                    React.createElement("thead", null,
                                        React.createElement("tr", null,
                                            React.createElement("th", { className: "action-column", style: {
                                                    padding: '0',
                                                    height: '1px',
                                                    border: 'none',
                                                } }),
                                            headers.map((e, i) => {
                                                return (React.createElement("th", { key: i, style: {
                                                        padding: '0',
                                                        height: '1px',
                                                        border: 'none',
                                                    } }));
                                            }))),
                                    React.createElement("tbody", null,
                                        React.createElement("tr", { onClick: () => handleRowOptionToggleClick(obj.id) },
                                            React.createElement("td", { style: { borderBottom: 'none' }, className: "action-column" },
                                                React.createElement(Icon, { name: "chevron-down", style: {
                                                        transform: openRowOptions.indexOf(obj.id) !== -1 ? 'rotate(180deg)' : '',
                                                    } })),
                                            Object.keys(obj.content).map((key, i) => {
                                                var _a;
                                                return (React.createElement("td", Object.assign({ key: i, style: {
                                                        borderBottom: 'none',
                                                    }, "data-heading": headers[i], title: createTitle(obj.content[key]) }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]));
                                            })),
                                        React.createElement("tr", { className: classNames('row-option', {
                                                open: openRowOptions.indexOf(obj.id) !== -1,
                                            }) },
                                            React.createElement("td", { className: "inner-table-cell", colSpan: headers.length + 1 }, obj.rowAccordionContent)))))));
                    }
                    else if (obj.lineItemLink) {
                        return (React.createElement("tr", Object.assign({ key: i, onClick: handleRowClick(obj.lineItemLink), className: classNames('hover', rowStyle) }, props.rowProps), Object.keys(obj.content).map((key, i) => {
                            var _a;
                            return (React.createElement("td", Object.assign({ key: i, "data-heading": headers[i], title: createTitle(obj.content[key]) }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]));
                        })));
                    }
                    else {
                        return (React.createElement("tr", Object.assign({ key: i, className: classNames(rowStyle) }, props.rowProps), Object.keys(obj.content).map((key, i) => {
                            var _a;
                            return (React.createElement("td", Object.assign({ key: i, "data-heading": headers[i], title: createTitle(obj.content[key]) }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]));
                        })));
                    }
                })))));
};
//# sourceMappingURL=SectionTable.js.map